webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questionnaire_vue__ = __webpack_require__(81);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49173967_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questionnaire_vue__ = __webpack_require__(112);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49173967"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questionnaire_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49173967_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questionnaire_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(40)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(43);
var defined = __webpack_require__(44);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(63);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(47);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(48), __esModule: true };

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
module.exports = __webpack_require__(37).Object.assign;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(50);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(60) });


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(37);
var ctx = __webpack_require__(51);
var hide = __webpack_require__(53);
var has = __webpack_require__(41);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(52);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(54);
var createDesc = __webpack_require__(59);
module.exports = __webpack_require__(39) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(55);
var IE8_DOM_DEFINE = __webpack_require__(56);
var toPrimitive = __webpack_require__(58);
var dP = Object.defineProperty;

exports.f = __webpack_require__(39) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(39) && !__webpack_require__(40)(function () {
  return Object.defineProperty(__webpack_require__(57)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);
var document = __webpack_require__(36).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(38);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(61);
var gOPS = __webpack_require__(72);
var pIE = __webpack_require__(73);
var toObject = __webpack_require__(74);
var IObject = __webpack_require__(43);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(40)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(62);
var enumBugKeys = __webpack_require__(71);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(41);
var toIObject = __webpack_require__(42);
var arrayIndexOf = __webpack_require__(64)(false);
var IE_PROTO = __webpack_require__(67)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(42);
var toLength = __webpack_require__(65);
var toAbsoluteIndex = __webpack_require__(66);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(45);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(45);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(68)('keys');
var uid = __webpack_require__(70);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(37);
var global = __webpack_require__(36);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(69) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 72 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(44);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable max-len */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Questionnaire',

  props: {
    quiz: {
      type: Object
    },
    currentProgress: {
      type: Number
    },
    showTimer: {
      type: Boolean
    },
    showAnswer: false,
    correctAnswer: {
      type: Boolean
    },
    isStatus: false,
    totalIndexes: null,
    currentQuesIndex: null,
    isDisabled: {
      type: Boolean
    }
  },

  created: function created() {
    this.startTimer();
  },
  destroyed: function destroyed() {
    this.stopTimer();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCurrentQuizIndex']), {
    progressBarRef: function progressBarRef() {
      return document.getElementById('dynamic');
    },
    timerLeftBar: function timerLeftBar() {
      return document.getElementById('leftBar');
    },
    timerRightBar: function timerRightBar() {
      return document.getElementById('rightBar');
    }
  }),

  mounted: function mounted() {
    this.progressBarRef.style.width = this.currentProgress + '%';
  },
  data: function data() {
    return {
      selectedOptionIndex: -1,
      timeLeft: 0,
      interval: null,
      status: null
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['updateScore']), {
    goToNextQuiz: function goToNextQuiz() {
      this.selectedOptionIndex = -1;
      this.stopTimer();
      this.timerLeftBar.classList.remove('progress-bar');
      this.timerRightBar.classList.remove('progress-bar');
      var a = this.timerLeftBar.offsetWidth;
      var b = this.timerRightBar.offsetWidth;
      this.progressBarRef.style.width = this.currentProgress + '%';
      this.$emit('nextQuiz');
      this.startTimer();
      if (!a || !b) {
        this.timerLeftBar.classList.add('progress-bar');
        this.timerRightBar.classList.add('progress-bar');
      }
    },
    checkAnswer: function checkAnswer(index) {
      var _this = this;

      this.progressBarRef.style.width = this.currentProgress + '%';
      this.stopTimer();
      this.selectedOptionIndex = index;
      this.$emit('optionClicked', index);
      var autoTimer = 3000;
      if (screen.width <= 575) {
        autoTimer = 1500;
      }
      var timer = setTimeout(function () {
        if (_this.showAnswer === false) {
          _this.startTimer();
        }
      }, autoTimer);
      var element = document.getElementsByClassName('next');
      element[0].addEventListener('click', function () {
        clearTimeout(timer);
      });
      element[1].addEventListener('click', function () {
        clearTimeout(timer);
      });
    },
    startTimer: function startTimer() {
      this.timeLeft = 20;
      this.interval = setInterval(this.countDown, 1000);
    },
    stopTimer: function stopTimer() {
      clearInterval(this.interval);
    },
    countDown: function countDown() {
      if (this.timeLeft > 0) {
        this.timeLeft -= 1;
      } else {
        this.goToNextQuiz();
      }
    }
  })
});

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(34)("c436871a", content, true, {});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(35);
exports = module.exports = __webpack_require__(33)(true);
// imports


// module
exports.push([module.i, ".Questionnaire[data-v-49173967]{background:#fafdff none repeat scroll 0 0;padding:25px 0 0;height:100vh}.Questionnaire .container[data-v-49173967]{max-width:1100px}.Questionnaire .disabled[data-v-49173967]{pointer-events:none;opacity:.8}.Questionnaire form[data-v-49173967]{padding:5px 0 0;position:relative}.Questionnaire .skip[data-v-49173967]{position:absolute;right:0;top:0}.Questionnaire .skip>a[data-v-49173967]{color:#c6d1dd;font-size:20px;font-family:Roboto,sans-serif;font-weight:300}.Questionnaire .skip>a[data-v-49173967]:hover{color:#54a3ff}.Questionnaire .progress[data-v-49173967]{height:2px;position:relative;overflow:visible;width:80%;padding:12px 0 100x;left:2%;right:90px;display:inline-block}.Questionnaire .progress-bar-data[data-v-49173967]{font-family:Roboto,sans-serif;font-size:16px;color:#54a3ff;top:9px;position:absolute;left:82%}.Questionnaire .progress .progress-bar[data-v-49173967]{height:1em!important;position:absolute;top:-5px;border-radius:16px;background:linear-gradient(264deg,#0180d0,#a0e3fd)}.Questionnaire ul#status[data-v-49173967]{margin:55px -220px;top:105px;width:100vw;text-align:center}.Questionnaire ul#status>li[data-v-49173967]{background:#fafdff none repeat scroll 0 0;border:3px solid #d9e2ee;border-radius:100%;display:inline-block;height:20px;position:relative;width:20px;margin:0 0 0 55px;z-index:2}.Questionnaire ul#status>li[data-v-49173967]:first-child{margin-left:0}.Questionnaire ul#status>li[data-v-49173967]:after{background:#d9e2ee none repeat scroll 0 0;content:\"\";height:3px;position:absolute;right:17px;top:5px;width:55px;z-index:1}.Questionnaire ul#status>li[data-v-49173967]:first-child:after{display:none}.Questionnaire ul#status>li.active[data-v-49173967]{border-color:#54a3ff}.Questionnaire ul#status>li.active[data-v-49173967]:after,.Questionnaire ul#status>li.passed[data-v-49173967]:after{background:#54a3ff none repeat scroll 0 0}.Questionnaire ul#status>li.passed[data-v-49173967]{background:#54a3ff url(" + escape(__webpack_require__(109)) + ") no-repeat 50%;border:3px solid rgba(84,163,255,.1);-webkit-box-shadow:0 0 15px 0 rgba(84,163,255,.7);box-shadow:0 0 15px 0 rgba(84,163,255,.7)}.Questionnaire .question-box[data-v-49173967]{margin:30px 0 50px}.Questionnaire .question-box h4.question[data-v-49173967]{color:#28282e;font-family:Roboto,sans-serif;font-size:40px;font-weight:400;line-height:55px;margin:0 0 55px;text-align:center}.Questionnaire ul.answers[data-v-49173967]{margin:0;text-align:center}.Questionnaire ul.answers>li[data-v-49173967]{background:#fff none repeat scroll 0 0;border:1px solid #e8f0f9;border-radius:6px;-webkit-box-shadow:0 2px 8px 0 rgba(217,226,238,.38);box-shadow:0 2px 8px 0 rgba(217,226,238,.38);color:#28282e;cursor:pointer;display:inline-block;font-size:28px;font-weight:200;letter-spacing:1px;line-height:120px;margin:0 1% 25px;min-height:120px;padding:15px 25px;text-align:left;vertical-align:middle;width:46%;position:relative}.Questionnaire ul.answers>li.selected[data-v-49173967]{border-color:#54a3ff;-webkit-box-shadow:0 0 0 2px #54a3ff;box-shadow:0 0 0 2px #54a3ff}.Questionnaire ul.answers>li[data-v-49173967]:hover{border-color:#bdd9f8;-webkit-box-shadow:0 0 0 2px #bdd9f8;box-shadow:0 0 0 2px #bdd9f8}.Questionnaire .answers input[data-v-49173967]{bottom:0;display:inline-block;height:42px;margin:auto;opacity:0;position:absolute;top:0;vertical-align:middle;width:42px;z-index:1}.Questionnaire .answers input+label[data-v-49173967]{display:inline-block;vertical-align:middle;margin:0;line-height:35px;position:relative;padding:0 0 0 80px}.Questionnaire .answers input+label[data-v-49173967]:before{background:#fff none repeat scroll 0 0;border:6px solid #d9e2ee;border-radius:100%;bottom:0;content:\"\";display:block;height:42px;left:0;margin:auto;position:absolute;top:0;width:42px}.Questionnaire .answers .right input+label[data-v-49173967]:before{background:transparent url(" + escape(__webpack_require__(110)) + ") no-repeat scroll 50%/20px auto;border-color:#3ec7a9}.Questionnaire ul.answers>li.right[data-v-49173967]{border-color:#3ec7a9!important;-webkit-box-shadow:0 0 0 2px #3ec7a9!important;box-shadow:0 0 0 2px #3ec7a9!important}.Questionnaire ul.answers>li.wrong[data-v-49173967]{border-color:#ff6d7f!important;-webkit-box-shadow:0 0 0 2px #ff6d7f!important;box-shadow:0 0 0 2px #ff6d7f!important}.Questionnaire .answerBox[data-v-49173967]{position:fixed;bottom:0;width:100%}.Questionnaire .quiz-answer[data-v-49173967]{background:#3ec7a9 none repeat scroll 0 0;padding:60px 0;margin-bottom:0}.Questionnaire .quiz-answer-inner[data-v-49173967]{margin:0 auto;max-width:1000px;padding:0 255px 27px 252px}.Questionnaire .quiz-answer p[data-v-49173967]{color:#fff;float:left;font-family:Roboto,sans-serif;font-size:24px;font-weight:400;margin:0;letter-spacing:1px}.Questionnaire .quiz-answer p i[data-v-49173967]{border:6px solid #fff;border-radius:100%;font-size:35px;font-weight:400;height:60px;line-height:47px;margin:0 20px 0 0;text-align:center;vertical-align:middle;width:60px}.Questionnaire .quiz-answer button[data-v-49173967]{background:#fff none repeat scroll 0 0;border:1px solid #fff;border-radius:24px;-webkit-box-shadow:0 6px 8px 0 rgba(94,105,119,.2);box-shadow:0 6px 8px 0 rgba(94,105,119,.2);float:right;height:48px;line-height:48px;padding:0 40px;color:#3ec7a9;font-size:21px;margin:6px 0 0;cursor:pointer;font-family:Roboto,sans-serif}.Questionnaire .quiz-answer button:hover .fa-angle-right[data-v-49173967]{font-size:20px;opacity:1;left:15px}.Questionnaire .quiz-answer button .fa-angle-right[data-v-49173967]{font-size:0;opacity:0;position:relative;left:0;-webkit-transition:all .5s linear;transition:all .5s linear}.Questionnaire .mobile[data-v-49173967]{display:none}.Questionnaire .quiz-answer button[data-v-49173967]:focus,.Questionnaire .quiz-answer button[data-v-49173967]:hover{background:none;color:#fff;-webkit-box-shadow:none;box-shadow:none}.Questionnaire ul.answers>li.selected.selected-false[data-v-49173967]{border-color:#ff6d7f;-webkit-box-shadow:0 0 0 2px #ff6d7f;box-shadow:0 0 0 2px #ff6d7f}.Questionnaire .answers .wrong input+label[data-v-49173967]:before{border-color:#ff6d7f;background:transparent url(" + escape(__webpack_require__(111)) + ") no-repeat scroll 50%/20px auto}.Questionnaire .quiz-answer.quiz-answer-false[data-v-49173967]{background:#ff6d7f none repeat scroll 0 0}.Questionnaire .quiz-answer.quiz-answer-false button[data-v-49173967]{color:#ff6d7f}.Questionnaire .quiz-answer.quiz-answer-false button[data-v-49173967]:focus,.Questionnaire .quiz-answer.quiz-answer-false button[data-v-49173967]:hover{color:#fff}.Questionnaire ul.answers.answers-img>li[data-v-49173967]{height:300px;line-height:270px;padding:15px;vertical-align:middle;width:260px;text-align:center}.Questionnaire ul.answers.answers-img>li img[data-v-49173967]{max-height:100%;max-width:100%}.Questionnaire .quiz-answer.quiz-timer[data-v-49173967]{background:#fff none repeat scroll 0 0;margin-top:-3%;padding:10px 0}.Questionnaire .quiz-answer.quiz-timer button[data-v-49173967]{background:transparent linear-gradient(263deg,#68ffed,#0575e6) repeat scroll 0 0;color:#fff}.Questionnaire .quiz-answer.quiz-timer button[data-v-49173967]:focus,.Questionnaire .quiz-answer.quiz-timer button[data-v-49173967]:hover{background:transparent linear-gradient(263deg,#0575e6,#68ffed) repeat scroll 0 0}.Questionnaire .timer-box[data-v-49173967]{margin:0 auto;text-align:center;width:90px}.Questionnaire .timer-box>span[data-v-49173967]{color:#28282e;display:block;font-size:12px;margin:8px 0 0}.Questionnaire .progress-blue[data-v-49173967]{width:100%;height:90px;line-height:90px;background:none;margin:0;-webkit-box-shadow:none;box-shadow:none;position:relative}.Questionnaire .progress-blue>span[data-v-49173967]{width:50%;height:100%;overflow:hidden;position:absolute;top:0;z-index:1}.Questionnaire .progress-blue .progress-left[data-v-49173967]{left:0}.Questionnaire .progress-blue .progress-bar[data-v-49173967]{width:100%;height:100%;background:none;border:6px solid #0575e6;position:absolute;top:0}.Questionnaire .progress-blue .progress-left .progress-bar[data-v-49173967]{left:100%;border-top-right-radius:80px;border-bottom-right-radius:80px;border-left:0;-webkit-transform-origin:center left;transform-origin:center left}.Questionnaire .progress-blue .progress-right[data-v-49173967]{right:0}.Questionnaire .progress-blue .progress-right .progress-bar[data-v-49173967]{left:-100%;border-top-left-radius:80px;border-bottom-left-radius:80px;border-right:0;-webkit-transform-origin:center right;transform-origin:center right;-webkit-animation:loading-1-data-v-49173967 10s linear forwards;animation:loading-1-data-v-49173967 10s linear forwards}.Questionnaire .progress-blue .progress-value[data-v-49173967]{border-radius:100%;color:#28282e;font-size:48px;font-weight:400;height:100%;text-align:center;width:100%}.Questionnaire .progress-blue .progress-left .progress-bar[data-v-49173967]{-webkit-animation:loading-2-data-v-49173967 10s linear forwards 10s;animation:loading-2-data-v-49173967 10s linear forwards 10s}@-webkit-keyframes loading-1-data-v-49173967{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}@keyframes loading-1-data-v-49173967{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}@-webkit-keyframes loading-2-data-v-49173967{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}@keyframes loading-2-data-v-49173967{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}.Questionnaire .que-img[data-v-49173967]{background:#fff none repeat scroll 0 0;border:1px solid #e8f0f9;border-radius:8px;-webkit-box-shadow:0 2px 8px 0 rgba(217,226,238,.38);box-shadow:0 2px 8px 0 rgba(217,226,238,.38);float:left;height:250px;margin:0 20px 0 0;padding:0;text-align:center;width:400px;line-height:220px;padding:15px}.Questionnaire .que-img>img[data-v-49173967]{max-height:100%;max-width:100%}.Questionnaire .question-box h4.question.question-img[data-v-49173967]{font-size:35px;line-height:45px;text-align:left}.Questionnaire .fade-enter-active[data-v-49173967],.Questionnaire .fade-leave-active[data-v-49173967]{-webkit-transition:opacity .4s;transition:opacity .4s}.Questionnaire .fade-enter[data-v-49173967],.Questionnaire .fade-leave-to[data-v-49173967]{opacity:0}.Questionnaire .fade-enter-to[data-v-49173967]{opacity:1}@media (min-width:1199px) and (max-width:2000px){.Questionnaire ul#status[data-v-49173967]{margin-left:-25%}}@media (min-width:992px) and (max-width:1199px){.Questionnaire .container[data-v-49173967]{max-width:960px}.Questionnaire ul#status[data-v-49173967]{margin-left:-20%}.Questionnaire ul#status>li[data-v-49173967]{margin-left:40px}.Questionnaire ul#status>li[data-v-49173967]:after{width:44px}}@media (max-width:991px){.Questionnaire .container[data-v-49173967]{max-width:720px}.Questionnaire ul#status[data-v-49173967]{margin-left:-20%}.Questionnaire ul#status>li[data-v-49173967]{margin-left:20px}.Questionnaire ul#status>li[data-v-49173967]:after{width:24px}.Questionnaire .question-box h4.question[data-v-49173967]{font-size:32px;line-height:40px}.Questionnaire ul.answers>li[data-v-49173967]{font-size:20px;padding:15px}.Questionnaire .answers input+label[data-v-49173967]{line-height:28px;padding-left:55px}.Questionnaire ul.answers.answers-img>li[data-v-49173967]{width:30%}.Questionnaire .que-img[data-v-49173967]{float:none;margin:0 auto 20px}.Questionnaire .question-box h4.question.question-img[data-v-49173967]{text-align:center}.Questionnaire .progress[data-v-49173967]{width:71%}.Questionnaire .progress-bar-data[data-v-49173967]{left:76%}.Questionnaire .quiz-answer-inner[data-v-49173967]{padding:0 147px 27px 173px}}@media (max-width:767px){.Questionnaire .container[data-v-49173967]{max-width:540px}.Questionnaire ul#status[data-v-49173967]{margin-left:-10%}.Questionnaire .quiz-menu[data-v-49173967]{float:none;margin:0 0 20px;text-align:center}.Questionnaire ul#status[data-v-49173967]{margin-left:100px;margin-bottom:10px;max-width:100%}.Questionnaire ul#status>li[data-v-49173967]{margin-left:30px}.Questionnaire ul#status>li[data-v-49173967]:after{width:34px}.Questionnaire .skip[data-v-49173967]{position:relative;right:auto;top:auto;margin:0 auto 20px;text-align:center}.Questionnaire ul.answers>li[data-v-49173967]{display:block;margin:0 0 20px;width:100%}.Questionnaire ul.answers.answers-img>li[data-v-49173967]{width:100%}.Questionnaire .progress[data-v-49173967]{left:2%;width:100%;right:90px}.Questionnaire .progress-bar-data[data-v-49173967]{top:-10px;position:absolute;left:46%}.Questionnaire .quiz-answer-inner[data-v-49173967]{padding:0 97px 27px 45px}}@media (max-width:575px){.Questionnaire .container[data-v-49173967]{max-width:100%}.Questionnaire .next[data-v-49173967]{display:none}.Questionnaire .progress[data-v-49173967]{left:0;width:71%;right:0}.Questionnaire .mobile[data-v-49173967]{display:inline-block;float:right;padding:0 27px;margin:0;cursor:pointer}.Questionnaire .mobile a[data-v-49173967]{font-size:18px;color:#a0a8b1;font-family:Roboto,sans-serif;text-decoration:none}.Questionnaire .mobile a[data-v-49173967]:hover{color:#a0a8b1}.Questionnaire .mobile .fa-angle-right[data-v-49173967]{font-size:20px;opacity:1;position:relative;left:10px}.Questionnaire ul#status[data-v-49173967]{margin-left:7%}.Questionnaire ul#status>li[data-v-49173967]{margin-left:6px}.Questionnaire ul#status>li[data-v-49173967]:after{width:10px}.Questionnaire .question-box h4.question[data-v-49173967]{font-size:20px;line-height:28px;margin-bottom:30px}.Questionnaire ul.answers>li[data-v-49173967]{font-size:18px;min-height:0;line-height:0}.Questionnaire .quiz-answer[data-v-49173967]{padding:4px 0}.Questionnaire .quiz-answer p i[data-v-49173967]{height:40px;width:40px;line-height:35px;border-width:3px;font-size:25px;margin-right:10px}.Questionnaire .quiz-answer p[data-v-49173967]{font-size:20px;padding-left:5px;float:none}.Questionnaire .quiz-answer-inner[data-v-49173967]{text-align:center;padding:4px}.Questionnaire .quiz-answer button[data-v-49173967]{display:none}.Questionnaire .que-img[data-v-49173967]{width:100%}}@media (max-width:400px){.Questionnaire .progress[data-v-49173967]{width:60%}.Questionnaire .mobile[data-v-49173967]{padding:0 20px;font-size:17px}.Questionnaire .mobile .fa[data-v-49173967]{font-size:17px}}.opaque[data-v-49173967]{height:100%;width:100%;top:0;left:0}.opaque .status[data-v-49173967],.opaque[data-v-49173967]{z-index:2;background:#757575;opacity:.5}.opaque .que-img[data-v-49173967],.opaque ul.answers>li[data-v-49173967]{background:#757575}", "", {"version":3,"sources":["/codebuild/output/src938119180/src/src/modules/Quiz/components/Questionnaire.vue"],"names":[],"mappings":"AACA,gCACE,0CAA2C,AAC3C,iBAAoB,AACpB,YAAc,CAIf,AACD,2CACI,gBAAkB,CACrB,AACD,0CACI,oBAAqB,AACrB,UAAa,CAChB,AACD,qCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,sCACI,kBAAmB,AACnB,QAAS,AACT,KAAO,CACV,AACD,wCACI,cAAe,AACf,eAAgB,AAChB,8BAAkC,AAClC,eAAiB,CACpB,AACD,8CACI,aAAe,CAClB,AACD,0CACI,WAAY,AACZ,kBAAmB,AACnB,iBAAkB,AAClB,UAAW,AACX,oBAAuB,AACvB,QAAS,AACT,WAAY,AACZ,oBAAsB,CACzB,AACD,mDACI,8BAAkC,AAClC,eAAgB,AAChB,cAAe,AACf,QAAS,AACT,kBAAmB,AACnB,QAAU,CACb,AACD,wDACI,qBAAuB,AACvB,kBAAmB,AACnB,SAAU,AACV,mBAAoB,AACpB,kDAAsD,CACzD,AACD,0CACI,mBAAyB,AACzB,UAAW,AACX,YAAa,AACb,iBAAmB,CACtB,AACD,6CACI,0CAA2C,AAC3C,yBAA0B,AAC1B,mBAAoB,AACpB,qBAAsB,AACtB,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,SAAW,CACd,AACD,yDACI,aAAe,CAClB,AACD,mDACI,0CAA2C,AAC3C,WAAY,AACZ,WAAY,AACZ,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,WAAY,AACZ,SAAW,CACd,AACD,+DACI,YAAc,CACjB,AACD,oDACI,oBAAsB,CACzB,AAID,oHACI,yCAA2C,CAC9C,AACD,oDACI,+DAAiF,AACjF,qCAA0C,AAC1C,kDAAuD,AAC/C,yCAA+C,CAC1D,AACD,8CACI,kBAAoB,CACvB,AACD,0DACI,cAAe,AACf,8BAAkC,AAClC,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,2CACI,SAAU,AACV,iBAAmB,CACtB,AACD,8CACI,uCAA2C,AAC3C,yBAA0B,AAC1B,kBAAmB,AACnB,qDAA0D,AAClD,6CAAkD,AAC1D,cAAe,AACf,eAAgB,AAChB,qBAAsB,AACtB,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,kBAAmB,AACnB,iBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,sBAAuB,AACvB,UAAW,AACX,iBAAmB,CACtB,AACD,uDACI,qBAAsB,AACtB,qCAAsC,AAC9B,4BAA8B,CACzC,AACD,oDACI,qBAAsB,AACtB,qCAAsC,AAC9B,4BAA8B,CACzC,AACD,+CACI,SAAU,AACV,qBAAsB,AACtB,YAAa,AACb,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,MAAO,AACP,sBAAuB,AACvB,WAAY,AACZ,SAAW,CACd,AACD,qDACI,qBAAsB,AACtB,sBAAuB,AACvB,SAAU,AACV,iBAAkB,AAClB,kBAAmB,AACnB,kBAAoB,CACvB,AACD,4DACI,uCAA2C,AAC3C,yBAA0B,AAC1B,mBAAoB,AACpB,SAAU,AACV,WAAY,AACZ,cAAe,AACf,YAAa,AACb,OAAU,AACV,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,UAAY,CACf,AACD,mEACI,oFAA4G,AAC5G,oBAAsB,CACzB,AACD,oDACI,+BAAiC,AACjC,+CAAiD,AACzC,sCAAyC,CACpD,AACD,oDACI,+BAAiC,AACjC,+CAAiD,AACzC,sCAAyC,CACpD,AACD,2CACI,eAAgB,AAChB,SAAU,AACV,UAAY,CACf,AACD,6CACI,0CAA2C,AAC3C,eAAgB,AAChB,eAAiB,CACpB,AACD,mDACI,cAAe,AACf,iBAAkB,AAClB,0BAA4B,CAC/B,AACD,+CACI,WAAe,AACf,WAAY,AACZ,8BAAkC,AAClC,eAAgB,AAChB,gBAAoB,AACpB,SAAU,AACV,kBAAoB,CACvB,AACD,iDACI,sBAA0B,AAC1B,mBAAoB,AACpB,eAAgB,AAChB,gBAAoB,AACpB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,sBAAuB,AACvB,UAAY,CACf,AACD,oDACI,uCAA2C,AAC3C,sBAA0B,AAC1B,mBAAoB,AACpB,mDAAwD,AAChD,2CAAgD,AACxD,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,cAAe,AACf,eAAgB,AAChB,eAAgB,AAChB,eAAgB,AAChB,6BAAkC,CACrC,AACD,0EACM,eAAgB,AAChB,UAAW,AACX,SAAW,CAChB,AACD,oEACM,YAAe,AACf,UAAW,AACX,kBAAmB,AACnB,OAAU,AACV,kCAAoC,AACpC,yBAA4B,CACjC,AACD,wCACI,YAAc,CACjB,AACD,oHAEI,gBAAiB,AACjB,WAAe,AACf,wBAAyB,AACjB,eAAiB,CAC5B,AACD,sEACI,qBAAsB,AACtB,qCAAsC,AAC9B,4BAA8B,CACzC,AACD,mEACI,qBAAsB,AACtB,mFAA6G,CAChH,AACD,+DACI,yCAA2C,CAC9C,AACD,sEACI,aAAe,CAClB,AACD,wJAEI,UAAY,CACf,AACD,0DACI,aAAc,AACd,kBAAmB,AACnB,aAAc,AACd,sBAAuB,AACvB,YAAa,AACb,iBAAmB,CACtB,AACD,8DACI,gBAAiB,AACjB,cAAgB,CACnB,AACD,wDACI,uCAA2C,AAC3C,eAAgB,AAChB,cAAgB,CACnB,AACD,+DACI,iFAAyF,AACzF,UAAe,CAClB,AACD,0IAEI,gFAAyF,CAC5F,AACD,2CACI,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,gDACI,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,cAAgB,CACnB,AACD,+CACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,SAAU,AACV,wBAAyB,AACjB,gBAAiB,AACzB,iBAAmB,CACtB,AACD,oDACI,UAAW,AACX,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACd,AACD,8DACI,MAAQ,CACX,AACD,6DACI,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,yBAA0B,AAC1B,kBAAmB,AACnB,KAAO,CACV,AACD,4EACI,UAAW,AACX,6BAA8B,AAC9B,gCAAiC,AACjC,cAAe,AACf,qCAAsC,AACtC,4BAA8B,CACjC,AACD,+DACI,OAAS,CACZ,AACD,6EACI,WAAY,AACZ,4BAA6B,AAC7B,+BAAgC,AAChC,eAAgB,AAChB,sCAAuC,AACvC,8BAA+B,AAC/B,gEAAiE,AACzD,uDAAyD,CACpE,AACD,+DACI,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,gBAAoB,AACpB,YAAa,AACb,kBAAmB,AACnB,UAAY,CACf,AACD,4EACI,oEAAqE,AAC7D,2DAA6D,CACxE,AACD,6CACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,iCAAkC,AAClC,wBAA0B,CAC7B,CACA,AACD,qCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,iCAAkC,AAClC,wBAA0B,CAC7B,CACA,AACD,6CACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,iCAAkC,AAClC,wBAA0B,CAC7B,CACA,AACD,qCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,iCAAkC,AAClC,wBAA0B,CAC7B,CACA,AACD,yCACI,uCAA2C,AAC3C,yBAA0B,AAC1B,kBAAmB,AACnB,qDAA0D,AAClD,6CAAkD,AAC1D,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,UAAW,AACX,kBAAmB,AACnB,YAAa,AACb,kBAAmB,AACnB,YAAc,CACjB,AACD,6CACI,gBAAiB,AACjB,cAAgB,CACnB,AACD,uEACI,eAAgB,AAChB,iBAAkB,AAClB,eAAiB,CACpB,AACD,sGACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,2FACI,SAAW,CACd,AACD,+CACI,SAAW,CACd,AACD,iDACA,0CACM,gBAAkB,CACvB,CACA,AACD,gDACA,2CACM,eAAiB,CACtB,AACD,0CACM,gBAAkB,CACvB,AACD,6CACM,gBAAkB,CACvB,AACD,mDACM,UAAY,CACjB,CACA,AACD,yBACA,2CACM,eAAiB,CACtB,AACD,0CACM,gBAAkB,CACvB,AACD,6CACM,gBAAkB,CACvB,AACD,mDACM,UAAY,CACjB,AACD,0DACM,eAAgB,AAChB,gBAAkB,CACvB,AACD,8CACM,eAAgB,AAChB,YAAc,CACnB,AACD,qDACM,iBAAkB,AAClB,iBAAmB,CACxB,AACD,0DACM,SAAW,CAChB,AACD,yCACM,WAAY,AACZ,kBAAoB,CACzB,AACD,uEACM,iBAAmB,CACxB,AACD,0CACM,SAAW,CAChB,AACD,mDACM,QAAU,CACf,AACD,mDACM,0BAA8B,CACnC,CACA,AACD,yBACA,2CACM,eAAiB,CACtB,AACD,0CACM,gBAAkB,CACvB,AACD,2CACM,WAAY,AACZ,gBAAiB,AACjB,iBAAmB,CACxB,AACD,0CACM,kBAAmB,AACnB,mBAAoB,AACpB,cAAgB,CACrB,AACD,6CACM,gBAAkB,CACvB,AACD,mDACM,UAAY,CACjB,AACD,sCACM,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,mBAAoB,AACpB,iBAAmB,CACxB,AACD,8CACM,cAAe,AACf,gBAAiB,AACjB,UAAY,CACjB,AACD,0DACM,UAAY,CACjB,AACD,0CACM,QAAS,AACT,WAAY,AACZ,UAAY,CACjB,AACD,mDACM,UAAW,AACX,kBAAmB,AACnB,QAAU,CACf,AACD,mDACM,wBAA4B,CACjC,CACA,AACD,yBACA,2CACM,cAAgB,CACrB,AACD,sCACM,YAAc,CACnB,AACD,0CACM,OAAQ,AACR,UAAW,AACX,OAAS,CACd,AACD,wCACM,qBAAsB,AACtB,YAAa,AACb,eAAgB,AAChB,SAAgB,AAChB,cAAgB,CACrB,AACD,0CACQ,eAAgB,AAChB,cAAe,AACf,8BAAkC,AAClC,oBAAsB,CAC7B,AACD,gDACU,aAAe,CACxB,AACD,wDACQ,eAAgB,AAChB,UAAW,AACX,kBAAmB,AACnB,SAAW,CAClB,AACD,0CACM,cAAgB,CACrB,AACD,6CACM,eAAiB,CACtB,AACD,mDACM,UAAY,CACjB,AACD,0DACM,eAAgB,AAChB,iBAAkB,AAClB,kBAAoB,CACzB,AACD,8CACM,eAAgB,AAChB,aAAgB,AAChB,aAAiB,CACtB,AACD,6CACM,aAAe,CACpB,AACD,iDACM,YAAa,AACb,WAAY,AACZ,iBAAkB,AAClB,iBAAkB,AAClB,eAAgB,AAChB,iBAAmB,CACxB,AACD,+CACM,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACjB,AACD,mDACM,kBAAmB,AACnB,WAAa,CAClB,AACD,oDACM,YAAc,CACnB,AACD,yCACM,UAAY,CACjB,CACA,AACD,yBACA,0CACM,SAAW,CAChB,AACD,wCACM,eAAgB,AAChB,cAAgB,CACrB,AACD,4CACQ,cAAgB,CACvB,CACA,AACD,yBACE,YAAa,AACb,WAAY,AACZ,MAAS,AACT,MAAU,CAIX,AACD,0DAJE,UAAW,AACX,mBAAoB,AACpB,UAAa,CAMd,AAID,yEACI,kBAAoB,CACvB","file":"Questionnaire.vue","sourcesContent":["\n.Questionnaire[data-v-49173967] {\n  background: #fafdff none repeat scroll 0 0;\n  padding: 25px 0 0px;\n  height: 100vh;\n  /*** quiz-false ***/\n  /*** quiz-timer ***/\n  /*** Responsive ***/\n}\n.Questionnaire .container[data-v-49173967] {\n    max-width: 1100px;\n}\n.Questionnaire .disabled[data-v-49173967] {\n    pointer-events: none;\n    opacity: 0.8;\n}\n.Questionnaire form[data-v-49173967] {\n    padding: 5px 0 0;\n    position: relative;\n}\n.Questionnaire .skip[data-v-49173967] {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n.Questionnaire .skip > a[data-v-49173967] {\n    color: #c6d1dd;\n    font-size: 20px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 300;\n}\n.Questionnaire .skip > a[data-v-49173967]:hover {\n    color: #54a3ff;\n}\n.Questionnaire .progress[data-v-49173967] {\n    height: 2px;\n    position: relative;\n    overflow: visible;\n    width: 80%;\n    padding: 12px 0 100x 0;\n    left: 2%;\n    right: 90px;\n    display: inline-block;\n}\n.Questionnaire .progress-bar-data[data-v-49173967] {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 16px;\n    color: #54a3ff;\n    top: 9px;\n    position: absolute;\n    left: 82%;\n}\n.Questionnaire .progress .progress-bar[data-v-49173967] {\n    height: 1em !important;\n    position: absolute;\n    top: -5px;\n    border-radius: 16px;\n    background: linear-gradient(264deg, #0180d0, #a0e3fd);\n}\n.Questionnaire ul#status[data-v-49173967] {\n    margin: 55px -220px 55px;\n    top: 105px;\n    width: 100vw;\n    text-align: center;\n}\n.Questionnaire ul#status > li[data-v-49173967] {\n    background: #fafdff none repeat scroll 0 0;\n    border: 3px solid #d9e2ee;\n    border-radius: 100%;\n    display: inline-block;\n    height: 20px;\n    position: relative;\n    width: 20px;\n    margin: 0 0 0 55px;\n    z-index: 2;\n}\n.Questionnaire ul#status > li[data-v-49173967]:first-child {\n    margin-left: 0;\n}\n.Questionnaire ul#status > li[data-v-49173967]::after {\n    background: #d9e2ee none repeat scroll 0 0;\n    content: \"\";\n    height: 3px;\n    position: absolute;\n    right: 17px;\n    top: 5px;\n    width: 55px;\n    z-index: 1;\n}\n.Questionnaire ul#status > li[data-v-49173967]:first-child::after {\n    display: none;\n}\n.Questionnaire ul#status > li.active[data-v-49173967] {\n    border-color: #54a3ff;\n}\n.Questionnaire ul#status > li.active[data-v-49173967]::after {\n    background: #54a3ff none repeat scroll 0 0;\n}\n.Questionnaire ul#status > li.passed[data-v-49173967]::after {\n    background: #54a3ff none repeat scroll 0 0;\n}\n.Questionnaire ul#status > li.passed[data-v-49173967] {\n    background: #54a3ff url(\"../../../assets/img/right.png\") no-repeat center center;\n    border: 3px solid rgba(84, 163, 255, 0.1);\n    -webkit-box-shadow: 0 0 15px 0 rgba(84, 163, 255, 0.7);\n            box-shadow: 0 0 15px 0 rgba(84, 163, 255, 0.7);\n}\n.Questionnaire .question-box[data-v-49173967] {\n    margin: 30px 0 50px;\n}\n.Questionnaire .question-box h4.question[data-v-49173967] {\n    color: #28282e;\n    font-family: \"Roboto\", sans-serif;\n    font-size: 40px;\n    font-weight: 400;\n    line-height: 55px;\n    margin: 0 0 55px;\n    text-align: center;\n}\n.Questionnaire ul.answers[data-v-49173967] {\n    margin: 0;\n    text-align: center;\n}\n.Questionnaire ul.answers > li[data-v-49173967] {\n    background: #ffffff none repeat scroll 0 0;\n    border: 1px solid #e8f0f9;\n    border-radius: 6px;\n    -webkit-box-shadow: 0 2px 8px 0 rgba(217, 226, 238, 0.38);\n            box-shadow: 0 2px 8px 0 rgba(217, 226, 238, 0.38);\n    color: #28282e;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 28px;\n    font-weight: 200;\n    letter-spacing: 1px;\n    line-height: 120px;\n    margin: 0 1% 25px;\n    min-height: 120px;\n    padding: 15px 25px;\n    text-align: left;\n    vertical-align: middle;\n    width: 46%;\n    position: relative;\n}\n.Questionnaire ul.answers > li.selected[data-v-49173967] {\n    border-color: #54a3ff;\n    -webkit-box-shadow: 0 0 0 2px #54a3ff;\n            box-shadow: 0 0 0 2px #54a3ff;\n}\n.Questionnaire ul.answers > li[data-v-49173967]:hover {\n    border-color: #bdd9f8;\n    -webkit-box-shadow: 0 0 0 2px #bdd9f8;\n            box-shadow: 0 0 0 2px #bdd9f8;\n}\n.Questionnaire .answers input[data-v-49173967] {\n    bottom: 0;\n    display: inline-block;\n    height: 42px;\n    margin: auto;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    vertical-align: middle;\n    width: 42px;\n    z-index: 1;\n}\n.Questionnaire .answers input + label[data-v-49173967] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    line-height: 35px;\n    position: relative;\n    padding: 0 0 0 80px;\n}\n.Questionnaire .answers input + label[data-v-49173967]::before {\n    background: #ffffff none repeat scroll 0 0;\n    border: 6px solid #d9e2ee;\n    border-radius: 100%;\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 42px;\n    left: 0px;\n    margin: auto;\n    position: absolute;\n    top: 0;\n    width: 42px;\n}\n.Questionnaire .answers .right input + label[data-v-49173967]::before {\n    background: rgba(0, 0, 0, 0) url(\"../../../assets/img/path-2.png\") no-repeat scroll center center/20px auto;\n    border-color: #3ec7a9;\n}\n.Questionnaire ul.answers > li.right[data-v-49173967] {\n    border-color: #3ec7a9 !important;\n    -webkit-box-shadow: 0 0 0 2px #3ec7a9 !important;\n            box-shadow: 0 0 0 2px #3ec7a9 !important;\n}\n.Questionnaire ul.answers > li.wrong[data-v-49173967] {\n    border-color: #ff6d7f !important;\n    -webkit-box-shadow: 0 0 0 2px #ff6d7f !important;\n            box-shadow: 0 0 0 2px #ff6d7f !important;\n}\n.Questionnaire .answerBox[data-v-49173967] {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n}\n.Questionnaire .quiz-answer[data-v-49173967] {\n    background: #3ec7a9 none repeat scroll 0 0;\n    padding: 60px 0;\n    margin-bottom: 0;\n}\n.Questionnaire .quiz-answer-inner[data-v-49173967] {\n    margin: 0 auto;\n    max-width: 1000px;\n    padding: 0 255px 27px 252px;\n}\n.Questionnaire .quiz-answer p[data-v-49173967] {\n    color: #ffffff;\n    float: left;\n    font-family: \"Roboto\", sans-serif;\n    font-size: 24px;\n    font-weight: normal;\n    margin: 0;\n    letter-spacing: 1px;\n}\n.Questionnaire .quiz-answer p i[data-v-49173967] {\n    border: 6px solid #ffffff;\n    border-radius: 100%;\n    font-size: 35px;\n    font-weight: normal;\n    height: 60px;\n    line-height: 47px;\n    margin: 0 20px 0 0;\n    text-align: center;\n    vertical-align: middle;\n    width: 60px;\n}\n.Questionnaire .quiz-answer button[data-v-49173967] {\n    background: #ffffff none repeat scroll 0 0;\n    border: 1px solid #ffffff;\n    border-radius: 24px;\n    -webkit-box-shadow: 0 6px 8px 0 rgba(94, 105, 119, 0.2);\n            box-shadow: 0 6px 8px 0 rgba(94, 105, 119, 0.2);\n    float: right;\n    height: 48px;\n    line-height: 48px;\n    padding: 0 40px;\n    color: #3ec7a9;\n    font-size: 21px;\n    margin: 6px 0 0;\n    cursor: pointer;\n    font-family: \"Roboto\", sans-serif;\n}\n.Questionnaire .quiz-answer button:hover .fa-angle-right[data-v-49173967] {\n      font-size: 20px;\n      opacity: 1;\n      left: 15px;\n}\n.Questionnaire .quiz-answer button .fa-angle-right[data-v-49173967] {\n      font-size: 0px;\n      opacity: 0;\n      position: relative;\n      left: 0px;\n      -webkit-transition: all 0.5s linear;\n      transition: all 0.5s linear;\n}\n.Questionnaire .mobile[data-v-49173967] {\n    display: none;\n}\n.Questionnaire .quiz-answer button[data-v-49173967]:hover,\n  .Questionnaire .quiz-answer button[data-v-49173967]:focus {\n    background: none;\n    color: #ffffff;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n.Questionnaire ul.answers > li.selected.selected-false[data-v-49173967] {\n    border-color: #ff6d7f;\n    -webkit-box-shadow: 0 0 0 2px #ff6d7f;\n            box-shadow: 0 0 0 2px #ff6d7f;\n}\n.Questionnaire .answers .wrong input + label[data-v-49173967]::before {\n    border-color: #ff6d7f;\n    background: rgba(0, 0, 0, 0) url(\"../../../assets/img/group-7.png\") no-repeat scroll center center/20px auto;\n}\n.Questionnaire .quiz-answer.quiz-answer-false[data-v-49173967] {\n    background: #ff6d7f none repeat scroll 0 0;\n}\n.Questionnaire .quiz-answer.quiz-answer-false button[data-v-49173967] {\n    color: #ff6d7f;\n}\n.Questionnaire .quiz-answer.quiz-answer-false button[data-v-49173967]:hover,\n  .Questionnaire .quiz-answer.quiz-answer-false button[data-v-49173967]:focus {\n    color: #fff;\n}\n.Questionnaire ul.answers.answers-img > li[data-v-49173967] {\n    height: 300px;\n    line-height: 270px;\n    padding: 15px;\n    vertical-align: middle;\n    width: 260px;\n    text-align: center;\n}\n.Questionnaire ul.answers.answers-img > li img[data-v-49173967] {\n    max-height: 100%;\n    max-width: 100%;\n}\n.Questionnaire .quiz-answer.quiz-timer[data-v-49173967] {\n    background: #ffffff none repeat scroll 0 0;\n    margin-top: -3%;\n    padding: 10px 0;\n}\n.Questionnaire .quiz-answer.quiz-timer button[data-v-49173967] {\n    background: rgba(0, 0, 0, 0) linear-gradient(263deg, #68ffed, #0575e6) repeat scroll 0 0;\n    color: #ffffff;\n}\n.Questionnaire .quiz-answer.quiz-timer button[data-v-49173967]:hover,\n  .Questionnaire .quiz-answer.quiz-timer button[data-v-49173967]:focus {\n    background: rgba(0, 0, 0, 0) linear-gradient(263deg, #0575e6, #68ffed) repeat scroll 0 0;\n}\n.Questionnaire .timer-box[data-v-49173967] {\n    margin: 0 auto;\n    text-align: center;\n    width: 90px;\n}\n.Questionnaire .timer-box > span[data-v-49173967] {\n    color: #28282e;\n    display: block;\n    font-size: 12px;\n    margin: 8px 0 0;\n}\n.Questionnaire .progress-blue[data-v-49173967] {\n    width: 100%;\n    height: 90px;\n    line-height: 90px;\n    background: none;\n    margin: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    position: relative;\n}\n.Questionnaire .progress-blue > span[data-v-49173967] {\n    width: 50%;\n    height: 100%;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    z-index: 1;\n}\n.Questionnaire .progress-blue .progress-left[data-v-49173967] {\n    left: 0;\n}\n.Questionnaire .progress-blue .progress-bar[data-v-49173967] {\n    width: 100%;\n    height: 100%;\n    background: none;\n    border: 6px solid #0575e6;\n    position: absolute;\n    top: 0;\n}\n.Questionnaire .progress-blue .progress-left .progress-bar[data-v-49173967] {\n    left: 100%;\n    border-top-right-radius: 80px;\n    border-bottom-right-radius: 80px;\n    border-left: 0;\n    -webkit-transform-origin: center left;\n    transform-origin: center left;\n}\n.Questionnaire .progress-blue .progress-right[data-v-49173967] {\n    right: 0;\n}\n.Questionnaire .progress-blue .progress-right .progress-bar[data-v-49173967] {\n    left: -100%;\n    border-top-left-radius: 80px;\n    border-bottom-left-radius: 80px;\n    border-right: 0;\n    -webkit-transform-origin: center right;\n    transform-origin: center right;\n    -webkit-animation: loading-1-data-v-49173967 10s linear forwards;\n            animation: loading-1-data-v-49173967 10s linear forwards;\n}\n.Questionnaire .progress-blue .progress-value[data-v-49173967] {\n    border-radius: 100%;\n    color: #28282e;\n    font-size: 48px;\n    font-weight: normal;\n    height: 100%;\n    text-align: center;\n    width: 100%;\n}\n.Questionnaire .progress-blue .progress-left .progress-bar[data-v-49173967] {\n    -webkit-animation: loading-2-data-v-49173967 10s linear forwards 10s;\n            animation: loading-2-data-v-49173967 10s linear forwards 10s;\n}\n@-webkit-keyframes loading-1-data-v-49173967 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n}\n@keyframes loading-1-data-v-49173967 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n}\n@-webkit-keyframes loading-2-data-v-49173967 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n}\n@keyframes loading-2-data-v-49173967 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n}\n.Questionnaire .que-img[data-v-49173967] {\n    background: #ffffff none repeat scroll 0 0;\n    border: 1px solid #e8f0f9;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 2px 8px 0 rgba(217, 226, 238, 0.38);\n            box-shadow: 0 2px 8px 0 rgba(217, 226, 238, 0.38);\n    float: left;\n    height: 250px;\n    margin: 0 20px 0 0;\n    padding: 0;\n    text-align: center;\n    width: 400px;\n    line-height: 220px;\n    padding: 15px;\n}\n.Questionnaire .que-img > img[data-v-49173967] {\n    max-height: 100%;\n    max-width: 100%;\n}\n.Questionnaire .question-box h4.question.question-img[data-v-49173967] {\n    font-size: 35px;\n    line-height: 45px;\n    text-align: left;\n}\n.Questionnaire .fade-enter-active[data-v-49173967], .Questionnaire .fade-leave-active[data-v-49173967] {\n    -webkit-transition: opacity .4s;\n    transition: opacity .4s;\n}\n.Questionnaire .fade-enter[data-v-49173967], .Questionnaire .fade-leave-to[data-v-49173967] {\n    opacity: 0;\n}\n.Questionnaire .fade-enter-to[data-v-49173967] {\n    opacity: 1;\n}\n@media (min-width: 1199px) and (max-width: 2000px) {\n.Questionnaire ul#status[data-v-49173967] {\n      margin-left: -25%;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.Questionnaire .container[data-v-49173967] {\n      max-width: 960px;\n}\n.Questionnaire ul#status[data-v-49173967] {\n      margin-left: -20%;\n}\n.Questionnaire ul#status > li[data-v-49173967] {\n      margin-left: 40px;\n}\n.Questionnaire ul#status > li[data-v-49173967]::after {\n      width: 44px;\n}\n}\n@media (max-width: 991px) {\n.Questionnaire .container[data-v-49173967] {\n      max-width: 720px;\n}\n.Questionnaire ul#status[data-v-49173967] {\n      margin-left: -20%;\n}\n.Questionnaire ul#status > li[data-v-49173967] {\n      margin-left: 20px;\n}\n.Questionnaire ul#status > li[data-v-49173967]::after {\n      width: 24px;\n}\n.Questionnaire .question-box h4.question[data-v-49173967] {\n      font-size: 32px;\n      line-height: 40px;\n}\n.Questionnaire ul.answers > li[data-v-49173967] {\n      font-size: 20px;\n      padding: 15px;\n}\n.Questionnaire .answers input + label[data-v-49173967] {\n      line-height: 28px;\n      padding-left: 55px;\n}\n.Questionnaire ul.answers.answers-img > li[data-v-49173967] {\n      width: 30%;\n}\n.Questionnaire .que-img[data-v-49173967] {\n      float: none;\n      margin: 0 auto 20px;\n}\n.Questionnaire .question-box h4.question.question-img[data-v-49173967] {\n      text-align: center;\n}\n.Questionnaire .progress[data-v-49173967] {\n      width: 71%;\n}\n.Questionnaire .progress-bar-data[data-v-49173967] {\n      left: 76%;\n}\n.Questionnaire .quiz-answer-inner[data-v-49173967] {\n      padding: 0px 147px 27px 173px;\n}\n}\n@media (max-width: 767px) {\n.Questionnaire .container[data-v-49173967] {\n      max-width: 540px;\n}\n.Questionnaire ul#status[data-v-49173967] {\n      margin-left: -10%;\n}\n.Questionnaire .quiz-menu[data-v-49173967] {\n      float: none;\n      margin: 0 0 20px;\n      text-align: center;\n}\n.Questionnaire ul#status[data-v-49173967] {\n      margin-left: 100px;\n      margin-bottom: 10px;\n      max-width: 100%;\n}\n.Questionnaire ul#status > li[data-v-49173967] {\n      margin-left: 30px;\n}\n.Questionnaire ul#status > li[data-v-49173967]::after {\n      width: 34px;\n}\n.Questionnaire .skip[data-v-49173967] {\n      position: relative;\n      right: auto;\n      top: auto;\n      margin: 0 auto 20px;\n      text-align: center;\n}\n.Questionnaire ul.answers > li[data-v-49173967] {\n      display: block;\n      margin: 0 0 20px;\n      width: 100%;\n}\n.Questionnaire ul.answers.answers-img > li[data-v-49173967] {\n      width: 100%;\n}\n.Questionnaire .progress[data-v-49173967] {\n      left: 2%;\n      width: 100%;\n      right: 90px;\n}\n.Questionnaire .progress-bar-data[data-v-49173967] {\n      top: -10px;\n      position: absolute;\n      left: 46%;\n}\n.Questionnaire .quiz-answer-inner[data-v-49173967] {\n      padding: 0px 97px 27px 45px;\n}\n}\n@media (max-width: 575px) {\n.Questionnaire .container[data-v-49173967] {\n      max-width: 100%;\n}\n.Questionnaire .next[data-v-49173967] {\n      display: none;\n}\n.Questionnaire .progress[data-v-49173967] {\n      left: 0;\n      width: 71%;\n      right: 0;\n}\n.Questionnaire .mobile[data-v-49173967] {\n      display: inline-block;\n      float: right;\n      padding: 0 27px;\n      margin: 0px 0 0;\n      cursor: pointer;\n}\n.Questionnaire .mobile a[data-v-49173967] {\n        font-size: 18px;\n        color: #a0a8b1;\n        font-family: \"Roboto\", sans-serif;\n        text-decoration: none;\n}\n.Questionnaire .mobile a[data-v-49173967]:hover {\n          color: #a0a8b1;\n}\n.Questionnaire .mobile .fa-angle-right[data-v-49173967] {\n        font-size: 20px;\n        opacity: 1;\n        position: relative;\n        left: 10px;\n}\n.Questionnaire ul#status[data-v-49173967] {\n      margin-left: 7%;\n}\n.Questionnaire ul#status > li[data-v-49173967] {\n      margin-left: 6px;\n}\n.Questionnaire ul#status > li[data-v-49173967]::after {\n      width: 10px;\n}\n.Questionnaire .question-box h4.question[data-v-49173967] {\n      font-size: 20px;\n      line-height: 28px;\n      margin-bottom: 30px;\n}\n.Questionnaire ul.answers > li[data-v-49173967] {\n      font-size: 18px;\n      min-height: 0px;\n      line-height: 0px;\n}\n.Questionnaire .quiz-answer[data-v-49173967] {\n      padding: 4px 0;\n}\n.Questionnaire .quiz-answer p i[data-v-49173967] {\n      height: 40px;\n      width: 40px;\n      line-height: 35px;\n      border-width: 3px;\n      font-size: 25px;\n      margin-right: 10px;\n}\n.Questionnaire .quiz-answer p[data-v-49173967] {\n      font-size: 20px;\n      padding-left: 5px;\n      float: none;\n}\n.Questionnaire .quiz-answer-inner[data-v-49173967] {\n      text-align: center;\n      padding: 4px;\n}\n.Questionnaire .quiz-answer button[data-v-49173967] {\n      display: none;\n}\n.Questionnaire .que-img[data-v-49173967] {\n      width: 100%;\n}\n}\n@media (max-width: 400px) {\n.Questionnaire .progress[data-v-49173967] {\n      width: 60%;\n}\n.Questionnaire .mobile[data-v-49173967] {\n      padding: 0 20px;\n      font-size: 17px;\n}\n.Questionnaire .mobile .fa[data-v-49173967] {\n        font-size: 17px;\n}\n}\n.opaque[data-v-49173967] {\n  height: 100%;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  z-index: 2;\n  background: #757575;\n  opacity: 0.5;\n}\n.opaque .status[data-v-49173967] {\n    z-index: 2;\n    background: #757575;\n    opacity: 0.5;\n}\n.opaque .que-img[data-v-49173967] {\n    background: #757575;\n}\n.opaque ul.answers > li[data-v-49173967] {\n    background: #757575;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/right.e83ae57.png";

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAAAAXNSR0IArs4c6QAAAa5JREFUSA211b1Lw0AUAPB7SfwAhyou+hfYxUEQKSiaIn6AQxH8GHVzctI/wsFBnNzFwRYd3DqI2doqDm6dBHFo66KiiCXpPfOiF+uZJmna3nJ5l7v345KXC7AOtfm7bJ9lvo9wVbk3xpZfiFE6Yem59Obnx2vJMq1bXjUr0/nMDjnQbmymkNlGzg/lvKqmTanyYCtxI4hyAuePbXuMfhBhCMpTWx5jEAQMHmIDPaMaqa20QAigDJqyeBFPvbk706/TQ4QaE2vlsHhIKGmMrxQpJ8wWzgdNNE8YsgUHAZbtYr0bl4lUxQ9tFqJcioW1AxeiERu1sGqIndKQ3KJAlENB5EtyMmQYxxq78gKjQg7GAJ5ljGIvsBWIcoJeyGxxzo8o8Gp22RZBZUlEWPU6GcQa+K46txjEeH3vVKOeP93nyJzzq/6mew1QYojDbixdhIFoyW/pB4ESIMKw0B+MgsAdCuGnbwaiJe7ORJ6wYLOQJ0aDQWAUqCHmB0aFKGfDX4yRWN+1v8E9miQand72oepb3mKuV//vncmTkjdnk2hZc/Q/ivV3H9PpLc8JG38BKKXpdkh+6Q0AAAAASUVORK5CYII="

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAf9JREFUOBGVlL9LHEEUx9+b3BlPCy2EtEGQwDVCGjurI5WSzi6VhUW8K7zmTJPxDkSQO6NJY0AE/wFJJbG0sggWgWCIzZEQCFgkRYrIefvyndGd3bm9vdWBhffzM/OW7wwTlrRaBWr/fUkUjBPTe97W30180JJKY4qkW0H9BL4j9ByYepaqLlKHPpFIwQKYAnogNd6qb6YBpayfIXeIo4y4GuYW7+gqS0V/BeyJS1iDhYRe8Tu94ceBuIF9gDXs5ZgDGnk4oRB87CWsI4wx1mVZ1+K5VJgpElHUuXoEoPyON0W2Dx0Is038g2aKF4pyqmJ+ZQSKW7fQ8us9RJNjulL+R6Re8MJCl03MjoYRYVnf1TnDbJiaA4ye81t9bModIBvq6DHDnCyCmYQDGud+0CQsAbwzVKRDrObCMU1fuIxs/MV0RhJc+8Eej1UOOn3aE7WuB3TSYM73K45ivqSieOwfOljvDYhXJ+zkjbInzIZl6DR2o5Ss1KexcYZoZT9b/HVcEMibroMGBONfdDdaKI21RfNYDIZ2m7K7m1conHT9nhHCbm+AeXkGQYVy9O1nSUHapx7HOj4szNvnLBWK/5wvnCsawijMn8Mm2JfYa76faE1NKhT65Y3V9s3jgNnpy69ZPDqjOPEJv9F/3AYphpQbJaJuE+kx9H3knbUlU/ofrHnUGzH6ST8AAAAASUVORK5CYII="

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Questionnaire"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"},[(_vm.quiz)?_c('form',[_vm._m(0),_vm._v(" "),_c('span',{key:_vm.currentProgress,staticClass:"progress-bar-data"},[_vm._v(_vm._s(_vm.currentProgress)+"%")]),_vm._v(" "),_c('div',{staticClass:"skip next",on:{"click":_vm.goToNextQuiz}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Skip Question")])]),_vm._v(" "),_c('div',{staticClass:"skip mobile",on:{"click":_vm.goToNextQuiz}},[_vm._m(1)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.quiz)?_c('div',{key:_vm.quiz.question,staticClass:"question-box"},[_c('h4',{staticClass:"question"},[_vm._v(_vm._s(_vm.quiz.question))]),_vm._v(" "),_c('ul',{staticClass:"answers"},_vm._l((_vm.quiz.options),function(option,index){return _c('li',{key:index,class:{'selected': index===_vm.selectedOptionIndex,
                      'right' : index===_vm.selectedOptionIndex && _vm.correctAnswer && _vm.isStatus,
                      'wrong' : index===_vm.selectedOptionIndex && !_vm.correctAnswer && _vm.isStatus,
                      'disabled': _vm.isDisabled,
                      },on:{"click":function($event){_vm.checkAnswer(index)}}},[_c('input',{attrs:{"type":"radio","name":"q1"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(option.option))])])}))]):_vm._e()])],1):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTimer),expression:"showTimer"}],staticClass:"quiz-answer quiz-timer"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{key:_vm.quiz.question,staticClass:"quiz-answer-inner"},[_c('div',{staticClass:"timer-box"},[_c('div',{staticClass:"progress-blue"},[_c('span',{staticClass:"progress-left"},[_c('span',{staticClass:"progress-bar",attrs:{"id":"leftBar"}})]),_vm._v(" "),_c('span',{staticClass:"progress-right"},[_c('span',{staticClass:"progress-bar",attrs:{"id":"rightBar"}})]),_vm._v(" "),_c('div',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.timeLeft))])]),_vm._v(" "),_c('span',[_vm._v("Seconds")])]),_vm._v(" "),_c('div',{staticClass:"clear"})])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAnswer),expression:"showAnswer"}],staticClass:"answerBox"},[(_vm.correctAnswer)?_c('div',{staticClass:"quiz-answer"},[_c('div',{staticClass:"quiz-answer-inner"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"next",on:{"click":_vm.goToNextQuiz}},[_vm._v("Next "),_c('i',{staticClass:"fa fa-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"clear"})])]):_c('div',{staticClass:"quiz-answer quiz-answer-false"},[_c('div',{staticClass:"quiz-answer-inner"},[_vm._m(3),_vm._v(" "),_c('button',{staticClass:"next",on:{"click":_vm.goToNextQuiz}},[_vm._v("Next "),_c('i',{staticClass:"fa fa-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"clear"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-success active",staticStyle:{"width":"0%"},attrs:{"id":"dynamic","role":"progressbar"}},[_c('span',{attrs:{"id":"current-progress"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Skip"),_c('i',{staticClass:"fa fa-angle-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v("That's Correct")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i',{staticClass:"fa fa-remove"}),_vm._v("That's Incorrect")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]);


// WEBPACK FOOTER //
// static/js/2.507b21baf061933d4e36.js